import i18n from '@/lang/i18n'

export default [{
  path: '/admin/apply/diy/homeIndex',
  name: 'homeIndex',
  component: () => import('@/views/apply/diy/homeIndex'),
  meta: {
    title: i18n.t('router.diy.diy_page'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/diy/addDiyPage',
  name: 'addDiyPage',
  component: () => import('@/views/apply/diy/addDiyPage'),
  meta: {
    title: i18n.t('router.diy.diy_decorate'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/diy/btoNavigation',
  name: 'btoNavigation',
  component: () => import('@/views/apply/diy/btoNavigation'),
  meta: {
    title: i18n.t('router.diy.bottom_navigation'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/diy/addBtoNavigation',
  name: 'addBtoNavigation',
  component: () => import('@/views/apply/diy/addBtoNavigation'),
  meta: {
    title: i18n.t('router.diy.add_bottom_navigation'),
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/diy.js